import { ObjectValues } from 'types';

export const DOWNLOAD_BANNER_STATUS = {
  PREPARING: 'preparing',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export const DOWNLOAD_BANNER_TYPE = {
  FILE: 'file',
  REPORT: 'report',
  ANALYTICS: 'analytics',
  LEAD_ANALYTICS: 'lead_analytics',
  BOSS_MODE: 'boss_mode',
  RFI_CATEGORIES: 'rfi_categories',
  ENTERPRISE_USAGE_REPORT: 'enterprise_usage_report',
} as const;

export type DownloadBannerStatus = ObjectValues<typeof DOWNLOAD_BANNER_STATUS>;

export type DownloadBannerType = ObjectValues<typeof DOWNLOAD_BANNER_TYPE>;

export type DownloadBannerContentProps = {
  message?: string;
  customTitle?: string;
  isClosable?: boolean;
};

export type DownloadBannerPayload = {
  status: DownloadBannerStatus;
  type?: DownloadBannerType;
} & DownloadBannerContentProps;
